// import React, { useEffect, useState } from 'react'
// import { getconsentStatusByUserId, getAaInsightsDataByUserId, getFiDataByUserId, getThreeMonthAggregatorAnalysisData } from '../AdminActionCreator.component'
// import { formatCurrency, formatDateLatest } from '../../../../utils/commonUtility'
// import Nodata from '../../../../images/nodata.png'
// import Pagination from '@mui/material/Pagination';
// import Loader from '../../../presentationals/Loader/Loader.component'
// import Popup from '../../../presentationals/Popup/Popup.component'
// import moment from 'moment'

// const itemsPerPage = 5;
// export default function AggregatorComponent({ allDetail }) {
//   const [loader, setLoader] = useState(false)
//   // const [DetailsData, setDetailsData] = useState({ parsedData: {}, accountData: {}, holderData: {}, transactions: [] })

//   const [viewDataType, setViewDataType] = useState({})
//   const [currentPage, setCurrentPage] = useState(1)
//   const [paginatedData, setPaginatedData] = useState([]);
//   const [popup, setPopup] = useState({ show: false, popupStatus: "" });
//   const [filters, setFilters] = useState({ type: "", subType: "" })
//   const [filterList, setFilterList] = useState([])
//   const [selectedData, setSelectedData] = useState({})
//   const [DetailsData,setDetailsData] =useState({})

//   useEffect(() => {
//     getconsentStatusByUserIdFn()
//     // getAaInsightsDataByUserIdFn()
//   }, [])

//   const getconsentStatusByUserIdFn = () => {
//     setLoader(true)
//     getconsentStatusByUserId(allDetail?.userId, callback => {
//       setLoader(false)
//       if (callback?.status == 200) {
//         getAaInsightsDataByUserIdFn()
//       } else {
//         setPopup({ show: true, popupStatus: "Please Provide Consent" })
//         removePopup()
//       }
//     })
//   }

//   const getAaInsightsDataByUserIdFn = () => {
//     // getAaInsightsDataByUserId(allDetail?.userId, callback => {
//     // getThreeMonthAggregatorAnalysisData(allDetail?.userId, callback => {
//     getThreeMonthAggregatorAnalysisData("8448664310", callback => {
//     // getAaInsightsDataByUserId("8448664310", callback => {
//       setLoader(false)
//       getFiDataByUserIdFn()
//       if (callback?.status == 200) {
//         const parsedData = JSON.parse(callback?.data)
//         setViewDataType(parsedData?.data?.overall)
//       } else {
//         setViewDataType({})
//       }
//     })
//   }
//   const getFiDataByUserIdFn = () => {
//     getFiDataByUserId(allDetail?.userId, callback => {
//     // getFiDataByUserId("8448664310", callback => {
//       setLoader(false)
//       if (callback?.status == 200) {
//         setDetailsData(callback?.data)
//       } else {

//         setDetailsData({})
//       }
//     })
//   }


//   const handleType = (e, type) => {
//     const value = e
//     setFilters((prev) => ({
//       ...prev,
//       [type]: value
//     }))
//     setCurrentPage(1)
//     if (type == "type") {
//       const data = Object.keys(viewDataType?.[value])?.length > 0 ? Object.keys(viewDataType?.[value])?.map(val => val) : []
//       setFilterList(data)
//       setFilters((prev) => ({
//         ...prev,
//         "subType": ""
//       }))
//     }
//     if (type == "subType") {
//       setSelectedData(viewDataType?.[filters?.type]?.[value])

//       handlePagePagination(1)
//       console.log("vssla", filters)
//       console.log("vla", viewDataType?.[filters?.type])
//       paginate(viewDataType?.[filters?.type]?.[value]?.transactions, 1);

//     }
//   }

//   const handlePagePagination = (e, value) => {
//     setCurrentPage(value);
//     console.log("vla", selectedData)
//     paginate(selectedData?.transactions, value);
//   };

//   const paginate = (data, page) => {
//     const startIndex = (page - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const sliced = data?.slice(startIndex, endIndex);
//     setPaginatedData(sliced);
//   };

//   const closePopup = () => {
//     setPopup({ show: false, popupStatus: '' })
//   }

//   const removePopup = () => {
//     setTimeout(() => {
//       closePopup()
//     }, 5000)
//   }



//   return (
//     <>

//       {loader ?
//         <Loader />
//         : ''}

//       {
//         popup?.show ?
//           <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
//           : ''}
//       {/* <div style={{display:'flex',justifyContent:'end',marginBottom:'10px'}}>
//           <button className='btn btn-primary' onClick={()=>handleRegenrate()}>Regenerate</button>
//         </div> */}
//       {
//         viewDataType ?
//           <>

//             <div style={{ backgroundColor: DetailsData?.Account?.Summary?.status == "ACTIVE" ? '#f0fdf4' : "#fdf0f0", borderRadius: '0.5rem', padding: '15px', border: DetailsData?.Account?.Summary?.status == "ACTIVE" ? '1px solid #bbf7d0' : '1px solid #f7bbbb' }}>
//               <h3 style={{ fontWeight: '600', color: '#1f2937', margin: ' 0 0 20px 0', fontSize: '20px' }}>Account Details</h3>
//               <div style={{ display: 'grid', gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: '1rem', fontSize: '0.875rem', lineHeight: '1.25rem' }}>
//                 <div style={{ marign: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Holder</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.name}</p>
//                 </div>
//                 <div style={{ marign: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Number</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.maskedAccNumber}</p>
//                 </div>
//                 <div style={{ margin: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Type</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.type}</p>
//                 </div>
//                 <div style={{ margin: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>IFSC Code</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.ifscCode}</p>
//                 </div>
//                 <div style={{ margin: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Branch</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.branch}</p>
//                 </div>
//                 <div style={{ margin: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Status</p>
//                   <p style={{ color: DetailsData?.Account?.Summary?.status == "ACTIVE" ? '#16a34a' : "#ff4c4c", fontSize: '14px', fontWeight: '500' }}>{DetailsData?.Account?.Summary?.status}</p>
//                 </div>
//                 <div style={{ margin: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Current Balance</p>
//                   <p style={{ color: '#16a34a', fontSize: '14px', fontWeight: '700' }}>{formatCurrency(DetailsData?.Account?.Summary?.currentBalance)}</p>
//                 </div>

//                 <div style={{ margin: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>MICR Code</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.micrCode}</p>
//                 </div>
//                 <div style={{ marign: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Mobile</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.mobile}</p>
//                 </div>
//                 <div style={{ marign: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>PAN</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.pan}</p>
//                 </div>
//                 <div style={{ marign: '0 0 10px 0' }}>
//                   <p style={{ color: '#4b5563', fontSize: '16px' }}>Address</p>
//                   <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.address}</p>
//                 </div>

//               </div>
//             </div>

//             <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid  #e5e7eb', margin: '20px 0' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', padding: '15px' }}>
//                 <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0', fontSize: '20px' }}>Transactions</h3>
//                 <div style={{ display: 'flex', gap: '10px' }}>
//                   <select value={filters?.type} onChange={(e) => handleType(e.target.value, "type")} style={{ width: '100px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }}>
//                     <option value="">Select Option</option>
//                     <option value="expense">Expenses</option>
//                     <option value="inflow">InFlow</option>
//                   </select>
//                   <select value={filters?.subType} onChange={(e) => handleType(e.target.value, "subType")} style={{ width: '100px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }}>
//                     <option value="">Select Option</option>
//                     {
//                       filterList?.length > 0 ? filterList?.map((val, id) => {
//                         return (
//                           <option value={val}>{val?.charAt(0)?.toUpperCase() + val?.slice(1)?.toLowerCase()}</option>
//                         )
//                       })
//                         : ''}
//                   </select>
//                 </div>
//               </div>
//               {/* { */}

//               <>
//                 <div className='customFinanceTable'>
//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ textAlign: "left" }}>Date</th>
//                         <th style={{ textAlign: "center" }}>Description</th>
//                         <th style={{ textAlign: "center" }}>Mode</th>
//                         <th style={{ textAlign: "center" }}>Type</th>
//                         <th style={{ textAlign: "right" }}>Amount</th>
//                         <th style={{ textAlign: "right" }}>Balance</th>
//                       </tr>
//                     </thead>
//                     <tbody className="custom-divide-y">
//                       {paginatedData?.length > 0 && paginatedData?.map((txn, index) => (
//                         <tr key={index}>
//                           <td style={{ textAlign: "left" }}>{moment(txn?.transactionTimestamp).format("DD-MM-YYYY HH:MM:SS")}</td>
//                           <td>{txn?.narration || ""}</td>
//                           <td>{txn?.mode || ""}</td>
//                           <td>
//                             <span
//                               style={{
//                                 display: 'inline-flex', padding: '8px', fontWeight: '500', borderRadius: '6px',
//                                 background: txn?.type === 'CREDIT' ? "#d1fae5" : "#fee2e2",
//                                 color: txn?.type === 'CREDIT' ? "#065f46" : "#991b1b"
//                               }}
//                             >
//                               {txn?.type || ""}
//                             </span>
//                           </td>
//                           <td style={{ textAlign: 'right', fontWeight: '500', color: txn?.type == "CREDIT" ? "16a34a" : "#dc2626" }}>
//                             {txn.type === 'CREDIT' ? '+' : '-'}{formatCurrency(txn?.amount)}
//                           </td>
//                           <td style={{ fontWeight: '500', textAlign: 'right' }}>
//                             {formatCurrency(txn?.currentBalance)}
//                           </td>
//                         </tr>
//                       ))
//                       }
//                     </tbody>
//                   </table>
//                 </div>

//                 <div style={{ margin: '15px', display: 'flex', justifyContent: 'end' }}>
//                   <Pagination
//                     count={Math.ceil(selectedData?.transactions?.length / itemsPerPage)}
//                     page={currentPage}
//                     onChange={handlePagePagination}
//                     variant="outlined"
//                     color="primary" shape="rounded"
//                   />
//                 </div>
//               </>
//               {/* :
//                   <div style={{ textAlign: 'center', margin: '20px 0' }}>
//                     <img src={Nodata} style={{ width: '40%' }} />
//                   </div>} */}
//             </div>

//           </>
//           :
//           <h3 style={{ marginTop: '40px' }} className="text-center"><img src={Nodata} width="300px" /></h3>
//       }


//     </>
//   )
// }





import React, { useEffect, useState } from 'react'
import { getconsentStatusByUserId, getAaInsightsDataByUserId, getFiDataByUserId, getThreeMonthAggregatorAnalysisData } from '../AdminActionCreator.component'
import { formatCurrency, formatDateLatest } from '../../../../utils/commonUtility'
import Nodata from '../../../../images/nodata.png'
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'
import moment from 'moment'

const itemsPerPage = 5;
export default function AggregatorComponent({ allDetail }) {
  const [loader, setLoader] = useState(false)

  const [viewDataType, setViewDataType] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [paginatedData, setPaginatedData] = useState([]);
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [filters, setFilters] = useState("transactions")
  const [filterList, setFilterList] = useState([])
  const [selectedData, setSelectedData] = useState({})
  const [DetailsData, setDetailsData] = useState({})

  useEffect(() => {
    getconsentStatusByUserIdFn()
    // getAaInsightsDataByUserIdFn()
  }, [])

  const getconsentStatusByUserIdFn = () => {
    setLoader(true)
    getconsentStatusByUserId(allDetail?.userId, callback => {
      setLoader(false)
      if (callback?.status == 200) {
        getAaInsightsDataByUserIdFn()
      } else {
        setPopup({ show: true, popupStatus: "Please Provide Consent" })
        removePopup()
      }
    })
  }

  const getAaInsightsDataByUserIdFn = () => {
    getThreeMonthAggregatorAnalysisData(allDetail?.userId, callback => {
    // getThreeMonthAggregatorAnalysisData("8448664310", callback => {
      setLoader(false)
      getFiDataByUserIdFn()
      if (callback) {
        setViewDataType(callback)
        setCurrentPage(1)
         setFilters("transactions")
        setSelectedData(callback?.transactions)
        paginate(callback?.transactions, 1);
      } else {
        setViewDataType({})
      }
    })
  }
  const getFiDataByUserIdFn = () => {
    getFiDataByUserId(allDetail?.userId, callback => {
      // getFiDataByUserId("8448664310", callback => {
      setLoader(false)
      if (callback?.status == 200) {
        setDetailsData(callback?.data)
      } else {

        setDetailsData({})
      }
    })
  }


  const handleType = (e) => {
    const value = e
    setFilters(e)
    setCurrentPage(1)

    setSelectedData(viewDataType?.[e])

    handlePagePagination(1)
    paginate(viewDataType?.[e], 1);
  }

  const handlePagePagination = (e, value) => {
    setCurrentPage(value);
    console.log("vla", selectedData)
    paginate(selectedData, value);
  };

  const paginate = (data, page) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const sliced = data?.slice(startIndex, endIndex);
    setPaginatedData(sliced);
  };

  const closePopup = () => {
    setPopup({ show: false, popupStatus: '' })
  }

  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }



  return (
    <>

      {loader ?
        <Loader />
        : ''}

      {
        popup?.show ?
          <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
          : ''}

      {
        viewDataType ?
          <>

            <div style={{ backgroundColor: DetailsData?.Account?.Summary?.status == "ACTIVE" ? '#f0fdf4' : "#fdf0f0", borderRadius: '0.5rem', padding: '15px', border: DetailsData?.Account?.Summary?.status == "ACTIVE" ? '1px solid #bbf7d0' : '1px solid #f7bbbb' }}>
              <h3 style={{ fontWeight: '600', color: '#1f2937', margin: ' 0 0 20px 0', fontSize: '20px' }}>Account Details</h3>
              <div style={{ display: 'grid', gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: '1rem', fontSize: '0.875rem', lineHeight: '1.25rem' }}>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Holder</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.name}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Number</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.maskedAccNumber}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Type</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.type}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>IFSC Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.ifscCode}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Branch</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.branch}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Status</p>
                  <p style={{ color: DetailsData?.Account?.Summary?.status == "ACTIVE" ? '#16a34a' : "#ff4c4c", fontSize: '14px', fontWeight: '500' }}>{DetailsData?.Account?.Summary?.status}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Current Balance</p>
                  <p style={{ color: '#16a34a', fontSize: '14px', fontWeight: '700' }}>{formatCurrency(DetailsData?.Account?.Summary?.currentBalance)}</p>
                </div>

                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>MICR Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Summary?.micrCode}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Mobile</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.mobile}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>PAN</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.pan}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Address</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.Account?.Profile?.Holders?.Holder?.address}</p>
                </div>

              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid  #e5e7eb', margin: '20px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', padding: '15px' }}>
                <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0', fontSize: '20px' }}>Transactions</h3>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <select value={filters} onChange={(e) => handleType(e.target.value)} style={{ width: '100px', padding: '10px', border: '1px solid #D3D9E9', borderRadius: '5px' }}>
                    <option value="">Select Option</option>
                    <option value="transactions">Transactions</option>
                    <option value="persona_insights">Personal Insights</option>
                    <option value="salary_analysis">Salary Analysis</option>
                    <option value="loan_analysis">Loan Analysis</option>
                    <option value="inflow">Inflow</option>
                    <option value="expenses">Expenses</option>
                  </select>

                </div>
              </div>
              {/* { */}

              <>
                <div className='customFinanceTable'>
                  <table>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>Date</th>
                        <th style={{ textAlign: "center" }}>Description</th>
                        <th style={{ textAlign: "center" }}>Mode</th>
                        <th style={{ textAlign: "center" }}>Type</th>
                        <th style={{ textAlign: "right" }}>Amount</th>
                        <th style={{ textAlign: "right" }}>Balance</th>
                      </tr>
                    </thead>
                    <tbody className="custom-divide-y">
                      {paginatedData?.length > 0 && paginatedData?.map((txn, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "left" }}>{moment(txn?.transactionTimestamp).format("DD-MM-YYYY HH:MM:SS")}</td>
                          <td>{txn?.narration || ""}</td>
                          <td>{txn?.mode || ""}</td>
                          <td>
                            <span
                              style={{
                                display: 'inline-flex', padding: '8px', fontWeight: '500', borderRadius: '6px',
                                background: txn?.type === 'CREDIT' ? "#d1fae5" : "#fee2e2",
                                color: txn?.type === 'CREDIT' ? "#065f46" : "#991b1b"
                              }}
                            >
                              {txn?.type || ""}
                            </span>
                          </td>
                          <td style={{ textAlign: 'right', fontWeight: '500', color: txn?.type == "CREDIT" ? "16a34a" : "#dc2626" }}>
                            {txn.type === 'CREDIT' ? '+' : '-'}{formatCurrency(txn?.amount)}
                          </td>
                          <td style={{ fontWeight: '500', textAlign: 'right' }}>
                            {formatCurrency(txn?.currentBalance)}
                          </td>
                        </tr>
                      ))
                      }
                    </tbody>
                  </table>
                </div>

                <div style={{ margin: '15px', display: 'flex', justifyContent: 'end' }}>
                  <Pagination
                    count={Math.ceil(selectedData?.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePagePagination}
                    variant="outlined"
                    color="primary" shape="rounded"
                  />
                </div>
              </>

            </div>

          </>
          :
          <h3 style={{ marginTop: '40px' }} className="text-center"><img src={Nodata} width="300px" /></h3>
      }


    </>
  )
}

